import {createSelector} from '@reduxjs/toolkit';

import {TAppState} from 'store/config/types';

import {AIS3_SLICE} from '../../../../store/slices/ais-slice/ais-slice-constants';

const selectAisSliceState = (state: TAppState) => state[AIS3_SLICE];

export const selectCommentsRequestTableDataNd = createSelector(selectAisSliceState, ({aisAnswerFormationNd}) => ({
    aisCommentsRequestTable: aisAnswerFormationNd.aisCommentsRequestTableNd,
}));

export const selectCommentsRequestRowsTableDataNd = createSelector(
    selectAisSliceState,
    ({aisAnswerFormationNd}) => aisAnswerFormationNd.aisInspectorCommentInfoNd
);
